/**
 * These constants are used in calculations for
 * the insurance values
 */
export const LIFE_INSURANCE_FACTOR_BASE = 1.85;
export const LIFE_INSURANCE_FACTOR_TOP = 2.45;
